export default __webpack_public_path__ + "static/media/loop-positive.8152debd.svg";